import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import blockDetailAPI from "../../api/BlockDetailAPI";

export const useFetchPageNameFromURL = ({
  url,
  isUrlDirty,
}: {
  url: string;
  isUrlDirty: boolean;
}) => {
  return useQuery<string, AxiosError<{ message: string }>>({
    queryKey: ["fetchPageName", url],
    queryFn: () => blockDetailAPI.getLinkOgs(url),
    enabled: !!url && url.length > 0 && isUrlDirty,
  });
};
